import { render } from "./GridTipuriDocIdentitate.vue?vue&type=template&id=5b3cbafc&ts=true"
import script from "./GridTipuriDocIdentitate.vue?vue&type=script&lang=ts"
export * from "./GridTipuriDocIdentitate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__